import { hotComments } from '@/mocks/home';

export default function HotComments() {
  return (
    <section id="comments" className="w-full">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16 lg:px-10">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.18em] text-primary-600">
              <i className="ri-chat-quote-line text-sm"></i>
              HOT COMMENTS
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
              今日热评速递
            </h2>
            <p className="mt-2 max-w-xl text-sm leading-relaxed text-foreground-600">
              从爱黑料网评论区里拎出当下最能带节奏的六条留言，每条都配一句短摘要，扫一眼就知道大家在吵什么。
            </p>
          </div>
          <a
            href="#comments"
            className="flex w-fit cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border px-4 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-100 hairline"
          >
            进入评论区
            <i className="ri-arrow-right-line text-base"></i>
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-px overflow-hidden rounded-lg border bg-background-300 hairline lg:grid-cols-2">
          {hotComments.map((item) => (
            <article
              key={item.rank}
              className="group flex cursor-pointer items-start gap-4 bg-background-50 p-4 transition-colors hover:bg-background-100 md:p-5"
            >
              <span
                className={`font-heading text-xl font-black leading-none md:text-2xl ${
                  item.rank === '01' ? 'text-primary-500' : 'text-background-400'
                }`}
              >
                {item.rank}
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-start justify-between gap-3">
                  <h3 className="font-heading text-sm font-bold leading-snug text-foreground-950 md:text-[15px]">
                    {item.title}
                  </h3>
                  <span className="shrink-0 rounded bg-secondary-100 px-2 py-0.5 text-[11px] font-semibold text-secondary-900">
                    {item.tag}
                  </span>
                </div>
                <p className="mt-2 text-xs leading-relaxed text-foreground-500 line-clamp-2 md:text-[13px]">
                  {item.summary}
                </p>
                <div className="mt-3 flex items-center gap-4 text-xs text-foreground-500">
                  <span className="flex items-center gap-1.5 font-semibold text-primary-600">
                    <i className="ri-heart-3-line text-sm"></i>
                    {item.likes}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-reply-line text-sm"></i>
                    参与讨论
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}